import React from "react";

import { formatDateForInput, getCurrentDate } from "../../../../lib/utils";

import ReportFormTable, { DateInputCell, NumberInputCell, ReportFormRow, } from "../../components/common/ReportTableForm";


export interface IncidentParticulars {
  exposure?: number;
  dateOfOccurrence?: string;
  dateOfDetection?: string;
  dateOfClassificationApproval?: string;
}

interface FICIncidentParticularsTableProps {
  incident: IncidentParticulars;
  onChange: (changes: Partial<IncidentParticulars>) => void;
  exposureError?: string | null;
  isNoFraud?: boolean;
}

export const FICIncidentParticularsTable: React.FC<FICIncidentParticularsTableProps> = ({
  incident,
  onChange,
  exposureError,
  isNoFraud = false,
}) => {
  const { exposure, dateOfOccurrence, dateOfDetection, dateOfClassificationApproval } = incident;

  const today = formatDateForInput(getCurrentDate());

  const formRows: ReportFormRow[] = [
    {
      label: "Date of Occurrence",
      disabled: isNoFraud,
      inputCell: (
        <DateInputCell
          value={dateOfOccurrence}
          onChange={(value) => onChange({ dateOfOccurrence: value })}
          disabled={isNoFraud}
          max={today}
        />
      ),
    },
    {
      label: "Date of Detection",
      disabled: isNoFraud,
      inputCell: (
        <DateInputCell
          value={dateOfDetection}
          onChange={(value) => onChange({ dateOfDetection: value })}
          disabled={isNoFraud}
          max={today}
        />
      ),
    },
    {
      label: "Fraud Amount Involved (in ₹ Lakhs)",
      disabled: isNoFraud,
      inputCell: (
        <div className="w-full">
          <NumberInputCell
            value={exposure}
            onChange={(value) => onChange({ exposure: value })}
            decimals={1}
            disabled={isNoFraud}
          />
          {exposureError && <p className="px-2 pb-1 text-xs text-red-600">{exposureError}</p>}
        </div>
      ),
    },
    {
      label: "Date of Classification (Approval from Competent Authority)",
      inputCell: (
        <DateInputCell
          value={dateOfClassificationApproval}
          onChange={(value) => onChange({ dateOfClassificationApproval: value })}
          max={today}
        />
      ),
    },
  ];

  return <ReportFormTable rows={formRows} />;
};
